export interface NewsData {
    news_id?: number
    title?: string
    date?: Date
    release_datetime?: Date
    limit_datetime?: Date
    delete_flug?: boolean
    link?: string
    news_detail?: string
    newsimg_id?: number
    newsimg_data?: string
}

export interface ObjectToNewsDataProps {
    news_id: number | string
    title: string
    date: string
    release_datetime?: string
    limit_datetime?: string
    delete_flug: boolean | string
    link?: string
    news_detail?: string
    newsimg_id?: number | string
}

export const ObjectToNewsData = (obj: ObjectToNewsDataProps): NewsData => {
    return {
        news_id: typeof obj.news_id == "string" ? parseInt(obj.news_id) : obj.news_id,
        title: obj.title,
        date: typeof obj.date == "string" ? new Date(obj.date) : obj.date,
        release_datetime: typeof obj.release_datetime == "string" ? new Date(obj.release_datetime) : obj.release_datetime,
        limit_datetime: typeof obj.limit_datetime == "string" ? new Date(obj.limit_datetime) : obj.limit_datetime,
        delete_flug: typeof obj.delete_flug === "string" ? obj.delete_flug == "1" : obj.delete_flug,
        link: (obj.link && obj.link.length > 0) ? obj.link : undefined,
        news_detail: (obj.news_detail && obj.news_detail.length > 0) ? obj.news_detail : undefined,
        newsimg_id: typeof obj.newsimg_id == "string" ? parseInt(obj.newsimg_id) : obj.newsimg_id,
    }
}